function updateClaimProductsKeys() {
    $('.js-claim-product').each(function(key, value) {
        const $claimProduct = $(this),
            claimRegex = /(products.*?)(\d+)(.*)/gm,
            claimSubst = `$1${key}$3`;

        $claimProduct.find('[data-key]').attr('data-key', key).data('key', key);
        $claimProduct.attr('data-key', key).data('key', key);

        $claimProduct.find('[id^=products]').each(function() {
            $(this).attr('id', $(this).attr('id').replace(claimRegex, claimSubst));
        });

        $claimProduct.find('[name^=products]').each(function() {
            $(this).attr('name', $(this).attr('name').replace(claimRegex, claimSubst));
        });

        $claimProduct.find('[for^=products]').each(function() {
            $(this).attr('for', $(this).attr('for').replace(claimRegex, claimSubst));
        });

        $claimProduct.find('.js-claim-product-key').html(`${key + 1}. `);
        $claimProduct.find('.js-claim-remove-product').toggleClass('hidden', key === 0);
    });
}

function createClaimProduct() {
    const $claimProduct = $('.js-claim-product[data-key="0"]').clone().insertAfter($('.js-claim-product:last')),
        $reasonInput = $claimProduct.find('[name="products[0][custom_claim_reason]"]');

    let reasonValue = $reasonInput.data('default');

    if (!$reasonInput.find(`option[value="${reasonValue}"]`).length) {
        reasonValue = $reasonInput.find('option:first').val();
    }

    $claimProduct.find('[id$="error"]').remove();

    $claimProduct.find('[name="products[0][custom_baris_id]"]').find(':selected').prop('selected', false);
    $claimProduct.find('[name="products[0][custom_baris_id]"]').val('').removeClass('error valid');
    $claimProduct.find('[name="products[0][quantity]"]').val(1).removeClass('error valid');
    $claimProduct.find('[name="products[0][price]"]').val('').removeClass('error valid');
    $claimProduct.find('[name="products[0][custom_invoice_number]"]').val('').removeClass('error valid');
    $claimProduct.find('[name="products[0][custom_invoice_number]"]').find('option').remove();
    $claimProduct.find('[name="products[0][custom_claim_reason]"]').val(reasonValue).removeClass('error valid');
    $claimProduct.find('[name="products[0][defect_description]"]').val('').removeClass('error valid');

    $claimProduct.find('.js-claims-select.is-loaded').each(function() {
        $(this).siblings('.btn-group').remove();
        $(this).removeClass('is-loaded');
    });

        buildClaimSelects();

    if ($claimProduct.offset().top + $claimProduct.height() / 2 > $(window).scrollTop() + $(window).height()) {
        $claimProduct.slideHere(20);
    }
}

function buildClaimSelects() {
    $('.js-claims-select:not(.is-loaded)').each(function() {
        let options = {};

        if ($(this).hasClass('has-filter')) {
            options = {
                enableFiltering: true,
                filterPlaceholder: $(this).data('filter-placeholder'),
                enableCaseInsensitiveFiltering: true,
                templates: {
                    filter: '<li class="multiselect-item filter c-form__item"><input class="c-form__input multiselect-search" type="text"></li>',
                    ul: '<ul class="multiselect-container dropdown-menu with-filter"></ul>',
                }
            }
        }

        if ($(this).hasClass('js-claims-invoice-select')) {
            options.nonSelectedText = $(this).data('non-selected-text');
        }

        $(this).multiselect(options);

        $(this).addClass('is-loaded');
    });
}

$(function() {
    setTimeout(function() {
        const claimValidator = $('.js-form-account-claim').validate();

        claimValidator.settings.ignore = '';

        claimValidator.settings.errorPlacement = function(error, element) {
            if ($(element).is('select:hidden')) {
                $(error).appendTo($(element).parent());
            } else {
                $(error).insertAfter($(element));
            }
        };

        claimValidator.settings.highlight = function( element, errorClass, validClass ) {
            if ($(element).is('select:hidden')) {
                $(element).siblings('.btn-group').find('.dropdown-toggle').addClass(errorClass).removeClass(validClass);
            } else {
                $(element).addClass(errorClass).removeClass(validClass);
            }
        };

        claimValidator.settings.unhighlight = function( element, errorClass, validClass ) {
            if ($(element).is('select:hidden')) {
                $(element).siblings('.btn-group').find('.dropdown-toggle').addClass(validClass).removeClass(errorClass);
            } else {
                $(element).removeClass(errorClass).addClass(validClass);
            }
        };

        $.validator.addClassRules('js-claims-defect-description', {
            minlength: 20
        });
    }, 1);

    $('.js-trigger-wishlist-clear').on('click', function(e) {
        e.preventDefault();

        let title = $(this).data('alert-title');

        Eshop.confirm(title, {}, function () {
            $('form[name="js-form-wishlist-clear"]').submit();
        });
    });

    $('.js-wishlist-delete').on('click', function(e) {
        e.preventDefault();

        let title = $(this).data('alert-title'),
            url = $(this).attr('href');

        Eshop.confirm(title, {}, function () {
            location.href = url;
        });
    });

    $('.js-claim-add-product').on('click', function() {
        createClaimProduct();
        updateClaimProductsKeys();
    });

    $('body').on('click', '.js-claim-remove-product', function() {
        const key = $(this).data('key'),
            $claimProduct = $(`.js-claim-product[data-key="${key}"]`);

        if (key == 0) {
            return;
        }

        Eshop.confirm($claimProduct.data('remove-text'), {
            cancelButtonText: $claimProduct.data('cancel-text'),
            confirmButtonText: $claimProduct.data('confirm-text'),
            confirmButtonColor: '#d0021c'
        }, function() {
            $claimProduct.remove();

            updateClaimProductsKeys();
        });
    });

    buildClaimSelects();

    $('body').on('change', '.js-claims-product-select', function() {
        const productId = $(this).val(),
            key = $(this).data('key'),
            $invoiceSelect = $(`.js-claims-invoice-select[data-key="${key}"]`);

        $(this).valid();

        $invoiceSelect.multiselect('dataprovider', []);
        $(`[name="products[${key}][price]"]`).val('');
        $(`[name="products[${key}][custom_invoice_number]"]`).find(':selected').prop('selected', false);

        if (!productId) {
            $invoiceSelect.multiselect('setOptions', { nonSelectedText: $invoiceSelect.data('non-selected-text') });
            $invoiceSelect.multiselect('rebuild');

            return;
        }

        $invoiceSelect.multiselect('setOptions', { nonSelectedText: $invoiceSelect.data('loading-text') });
        $invoiceSelect.multiselect('rebuild');

        $.post($(this).data('invoices-url'), {productId: productId}, function(response) {
            $invoiceSelect.multiselect('dataprovider', response.options);
            $invoiceSelect.data('prices', response.prices);
            $invoiceSelect.data('quantities', response.quantities);

            if ($invoiceSelect.data('value')) {
                $invoiceSelect.multiselect('select', $invoiceSelect.data('value'));
                $invoiceSelect.data('value', '');
            }

            $invoiceSelect.trigger('change');
        }, 'json');
    });

    $('body').on('change', '.js-claims-invoice-select', function() {
        const invoiceId = $(this).val(),
            key = $(this).data('key'),
            productPrices = $(this).data('prices'),
            productQuantities = $(this).data('quantities');

        $(this).valid();

        $(`[name="products[${key}][price]"]`).val(productPrices[invoiceId]);
        $(`[name="products[${key}][quantity]"]`).attr('max', productQuantities[invoiceId]);
    });

    $('body').on('change', '.js-claims-address-select', function() {
        const addressId = $(this).val(),
            phoneNumbers = $(this).data('phone-numbers');

        let phoneNumber = null;

        if (phoneNumbers) {
            phoneNumber = phoneNumbers[addressId];
        }

        $(this).valid();

        $('[name="customer_phone"]').val(phoneNumber);
    });

    $('.js-claim-product').each(function(key, value) {
        const $claimProductSelect = $(this).find('.js-claims-product-select'),
            $claimInvoiceSelect = $(this).find('.js-claims-invoice-select');

        if ($claimInvoiceSelect.data('value')) {
            $claimProductSelect.trigger('change');
        }
    });
});